function getOverrideValidationConstraints(ids, httpClient) {
  const body = JSON.stringify({ chassisIds: ids || [] })

  return httpClient({
    url: '/chassis/override-validation-constraints',
    method: 'POST',
    data: body,
  }).then((res) => res.data)
}

function overrideValidation(ids, httpClient) {
  const body = JSON.stringify({ chassisIds: ids || [] })

  return httpClient({
    url: '/chassis/override-validation',
    method: 'POST',
    data: body,
  }).then((res) => res.data)
}

function deleteBulk(chassisIds, httpClient) {
  const body = JSON.stringify(chassisIds)

  return httpClient({
    url: `/chassis/bulk`,
    method: 'DELETE',
    data: body,
  })
}

function validateBulkUpload(chassisData, httpClient) {
  const body = JSON.stringify({ chassisData })

  return httpClient({
    url: '/chassis/bulk-validate',
    method: 'POST',
    data: body,
  }).then((res) => res.data)
}

function startBulkUpload(httpClient) {
  return httpClient({
    url: '/upload/bulk-chassis',
    method: 'POST',
  }).then((res) => res.data)
}

function performBulkUpload(uploadDetails, csvData, httpClient) {
  // For multipart upload to S3
  if (uploadDetails.method === 'multipart') {
    const formData = new FormData()
    Object.entries(uploadDetails.fields).forEach(([key, value]) => {
      formData.append(key, value)
    })
    // Create a Blob from the CSV data
    const blob = new Blob([csvData], { type: 'text/csv' })
    formData.append('file', blob, 'chassis-bulk-upload.csv')

    return httpClient({
      url: uploadDetails.url,
      method: uploadDetails.httpVerb || 'POST',
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  }

  // For direct PUT upload
  return httpClient({
    url: uploadDetails.url || uploadDetails.uploadUrl,
    method: uploadDetails.httpVerb || 'PUT',
    data: csvData,
    headers: {
      'Content-Type': 'text/csv',
    },
  })
}

function recordImportCorrections(corrections, httpClient) {
  return httpClient({
    url: '/chassis/record-import-corrections',
    method: 'POST',
    data: JSON.stringify({ corrections }),
  }).then((res) => res.data)
}

export default {
  getOverrideValidationConstraints,
  overrideValidation,
  deleteBulk,
  validateBulkUpload,
  startBulkUpload,
  performBulkUpload,
  recordImportCorrections,
}
